import config from '../../config';
import { request } from '../../libraries/request'

const getAll = (params = {}, token) => {
  console.log('SERVICES::INITIATIVE_ASSISTANCES::getAll', params, token);
  if (params?.page_num && config.QUERIES_PAGE_SIZE) {
    params.page_size = config.QUERIES_PAGE_SIZE;
  }
  if (!params.order_by) { 
    params.order_by = 'assistant';
    params.order_direction = 'ASC';
  }

  return request({
    url: `${config.BASE_API_URL}${config.API.INITIATIVE_ASSISTANCES.replace('{id}', params.initiativeID)}`,
    accessToken: token,
    // data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      response.data.query.page_size = config.QUERIES_PAGE_SIZE;
    }
    return response;
  })
}

const save = (data, token, id) => {
  console.log('SERVICES::INITIATIVE_ASSISTANCES::save', data, token, id);
  return request({
    url: `${config.BASE_API_URL}${config.API.INITIATIVE_ASSISTANCES.replace('{id}', id)}`,
    accessToken: token,
    method: 'POST',
    data,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const update = (data, token) => {
  console.log('SERVICES::INITIATIVE_ASSISTANCES::update', data, token);
  console.warn('PATCH FUNCTIONALITY NOT DEVELOPED')
  return;
  /* return request({
    url: config.BASE_API_URL + config.API.INITIATIVE.replace('{id}', data.id),
    accessToken: token,
    method: 'PATCH',
    data,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  }) */
}

const get = (params, token, data) => {
  console.log('SERVICES::INITIATIVE_ASSISTANCES::get', params, data, token);
  return request({
    url: `${config.BASE_API_URL}${config.API.INITIATIVE_ASSISTANCE.replace('{initiativeId}', params.initiativeID).replace('{id}', params.id)}`,
    accessToken: token,
    data,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })

}

const del = (params, token) => {
  console.log('SERVICES::INITIATIVE_ASSISTANCES::remove', params, token);
  return request({
    url: `${config.BASE_API_URL}${config.API.INITIATIVE_ASSISTANCE.replace('{initiativeId}', params.initiativeID).replace('{id}', params.id)}`,
    accessToken: token,
    method: 'DELETE',
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const services = {
  getAll,
  save,
  get,
  del,
  update,
};

export default services;